import React from "react";
import { ShieldAlert } from "lucide-react";

export const SensitiveDisclosure = ({ data }) => {
    if (!data) return null;
    return (
        <section className="panel" data-testid="sensitive-disclosure">
            <div className="px-6 sm:px-8 py-5 border-b hairline flex items-start justify-between gap-6">
                <div>
                    <p className="mono-label">Governance extension · 01</p>
                    <h2
                        className="font-serif mt-1"
                        style={{ fontSize: 28, letterSpacing: "-0.01em" }}
                    >
                        {data.title}
                    </h2>
                </div>
                <div
                    className="hidden sm:inline-flex items-center gap-2 border border-[var(--rule)] px-3 py-1.5"
                    style={{ background: "#FFF8E6" }}
                >
                    <ShieldAlert size={14} strokeWidth={1.5} />
                    <span className="mono-label" style={{ color: "var(--ink)" }}>
                        Disclosure lock available
                    </span>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2">
                <div className="px-6 sm:px-8 py-6 lg:border-r hairline">
                    <p className="mono-label">Framing</p>
                    <p
                        className="font-serif mt-3"
                        style={{ fontSize: 16.5, lineHeight: 1.55 }}
                    >
                        {data.framing}
                    </p>
                    <p
                        className="mt-5 font-serif"
                        style={{
                            fontSize: 15,
                            color: "var(--forest)",
                            lineHeight: 1.55,
                        }}
                    >
                        {data.required_line}
                    </p>
                </div>
                <div className="px-6 sm:px-8 py-6">
                    <p className="mono-label">Governed disclosure flow</p>
                    <ol className="mt-3 space-y-2">
                        {(data.governed_flow || []).map((step, i) => (
                            <li
                                key={i}
                                className="flex items-baseline gap-3"
                                data-testid={`disclosure-step-${i + 1}`}
                            >
                                <span
                                    className="font-mono"
                                    style={{
                                        fontSize: 11,
                                        color: "var(--ink-muted)",
                                        minWidth: 22,
                                    }}
                                >
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <span style={{ fontSize: 14.5 }}>{step}</span>
                            </li>
                        ))}
                    </ol>
                </div>
            </div>

            <div className="px-6 sm:px-8 py-5 border-t hairline panel-alt">
                <p className="mono-label mb-2">Must not claim</p>
                <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-1">
                    {(data.must_not_claim || []).map((c, i) => (
                        <li
                            key={i}
                            style={{
                                fontSize: 13.5,
                                color: "var(--ink-soft)",
                            }}
                        >
                            · {c}
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default SensitiveDisclosure;
